<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema, $ } from '@bagelink/vue'
const defaults = {
	endorsements: [{
		id: 1,
		body: 'A thoughtful endorsement of this publication.',
		name: 'Prof. Example Scholar',
	}],
}
const schema = defineSchema({
	endorsements: $.array('Endorsements', defineSchema({
		id: $.text('ID'),
		body: $.richtext('Body', { basic: true }),
		name: $.text('Name'),
	}), { collapsible: true }),
})
export const StoreEndorsements = defineBlock({ thumbnail: '/block-thumbs/StoreEndorsements.svg', category: 'Content', order: 370, name: 'StoreEndorsements', label: 'Store Endorsements', icon: 'format_quote', schema, defaults })
</script>
<script setup lang="ts">


import BlockTestimonials from '@/components/blocks/BlockTestimonials.vue'

// Kept for CMS backward-compatibility. Delegates to the generic
// `BlockTestimonials` (identical look to the original Store Endorsements).



interface Endorsement {
	id: number
	body: string
	name: string
}

const props = defineProps<{
	endorsements?: Endorsement[]
}>()
</script>

<template>
	<BlockTestimonials v-bind="{ title: 'Endorsements', endorsements: props.endorsements }" />
</template>
